import { Controller } from '@hotwired/stimulus'

// Computer / Phone toggle for a preview frame: the frame takes the screen's width, the page inside lays itself out.
// Optional surface buttons (data-src) swap what the frame shows.
// Opt in with form + fields values to preview a form's unsaved radios: `sync` (on show.bs.modal) rewrites the
// frame's and every surface's query from the checked radio named for each param, e.g. {"nav_style":"iframe_menu[premium_nav_style]"}.
const WIDTHS = { desktop: '100%', mobile: '375px' }

export default class extends Controller {
  static targets = ['frame', 'device', 'surface']
  static values = { form: String, fields: Object }

  pick(event) {
    this.frameTarget.style.width = WIDTHS[event.currentTarget.dataset.device] || '100%'
    this.press(this.deviceTargets, event.currentTarget)
  }

  show(event) {
    this.frameTarget.src = event.currentTarget.dataset.src
    this.press(this.surfaceTargets, event.currentTarget)
  }

  sync() {
    const form = this.hasFormValue && document.querySelector(this.formValue)
    const query = {}
    Object.entries(this.fieldsValue).forEach(([param, name]) => {
      const checked = form && form.querySelector(`input[name="${name}"]:checked`)
      if (checked) query[param] = checked.value
    })
    if (Object.keys(query).length === 0) return

    this.surfaceTargets.forEach((button) => { button.dataset.src = this.withQuery(button.dataset.src, query) })
    // Only a changed src reloads the frame.
    const src = this.withQuery(this.frameTarget.getAttribute('src'), query)
    if (src !== this.frameTarget.getAttribute('src')) this.frameTarget.src = src
  }

  withQuery(path, query) {
    const url = new URL(path, window.location.href)
    Object.entries(query).forEach(([param, value]) => url.searchParams.set(param, value))
    return url.pathname + url.search
  }

  press(buttons, current) {
    buttons.forEach((button) => {
      const active = button === current
      button.classList.toggle('active', active)
      button.setAttribute('aria-pressed', active)
    })
  }
}
